import { useContext, useDebugValue } from 'react';

import AuthContext from '../Contexts/AuthProvider';

const useAuth = () => {
    const { auth } = useContext(AuthContext);
    useDebugValue(auth, auth => auth?.user ? 'Logged In' : 'Logged Out');
    return useContext(AuthContext);
};
/*
email,
                    roles,
                    accessToken,
                    completeStep,
                    'photo': response?.data.user.collaboratorId?.persoData?.photo
                        || response?.data.user.expertId?.persoData?.photo ||
                        response?.data.user.backOfficeId?.persoData?.photo ||
                        'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
                    'nom': response?.data.user.collaboratorId?.persoData?.nom
                        || response?.data.user.expertId?.persoData?.nom ||
                        response?.data.user.backOfficeId?.persoData?.nom,
                    'prenom': response?.data.user.collaboratorId?.persoData?.prenom
                        || response?.data.user.expertId?.persoData?.prenom ||
                        response?.data.user.backOfficeId?.persoData?.prenom
*/
export default useAuth;

export const setAuthentificationInfo = ({ email, roles, acessToken, completeStep, photo, nom, prenom }) => {
    const { setAuth } = useAuth();
    setAuth({
        email, roles, acessToken, completeStep,
        'photo': photo || 'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
        nom, prenom
    });
};